<template>
    <div>
        <base-modal id="modalUser" :fullscreen="true">
            <div class="modal-header"></div>
            <div class="modal-body">
                <template v-if="status">
                    <user-picture v-if="user" :user="user" size="-xlarge" border="-border-white" />
                    <user-card v-if="user" :user="user" />

                    <p v-if="aboutComputed">{{ aboutComputed }}</p>

                    <slot />

                    <p>Se você desejar falar comigo rapidamente meu telefone é:</p>
                    <p class="phone" v-if="phoneComputed">{{ phoneComputed }}</p>

                    <user-social-list v-if="user" :user="user" />
                </template>

                <template v-else>
                    <p class="alert -warning">
                        Não conseguimos encontrar as informações do Corretor.
                    </p>
                </template>

                <button class="button -xlarge -contrast" @click="close" type="button">
                    Voltar para o site
                </button>
            </div>
        </base-modal>
    </div>
</template>

<script>
    import BaseModal from '@/Components/BaseModal'
    import UserCard from '@/Components/User/UserCard'
    import UserPicture from '@/Components/User/UserPicture'
    import UserSocialList from '@/Components/User/UserSocialList'

    export default {
        components: {
            BaseModal,
            UserCard,
            UserPicture,
            UserSocialList,
        },

        props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        computed: {
            status() {
                return this.user ? true : false
            },

            aboutComputed() {
                return this.user && this.user.about ? this.user.about : false
            },

            phoneComputed() {
                return this.user && this.user.phone ? this.user.phone : false
            },
        },

        methods: {
            close() {
                this.$root.$emit('hideModal', 'modalUser')
            },
        },
    }
</script>

<style lang="stylus" scoped></style>
